import StatisticsJobPage from "./statisticsJobPage.component"

export default StatisticsJobPage
